import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Flex, Box } from 'rebass';

import { ManageAllButton } from 'components';

const StyledBox = styled(Box)`
  text-align: right;
`;

const GuestListFooter = ({ onManageAll }) => (
  <Flex py={3} align="center">
    <Box width={37 / 48} />
    <StyledBox width={11 / 48}>
      <ManageAllButton onClick={onManageAll} />
    </StyledBox>
  </Flex>
);

GuestListFooter.propTypes = {
  onManageAll: PropTypes.func,
};
GuestListFooter.defaultProps = {
  onManageAll: () => {},
};

export default GuestListFooter;



// WEBPACK FOOTER //
// ./src/components/organisms/GuestListFooter/index.js